function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2148 19.3828C13.7715 19.3828 14.3574 19.3633 15.0703 19.2559C15.8418 19.1387 16.8574 18.6406 16.8574 17.4297C16.8574 16.3945 16.1543 15.75 15.0996 15.75C14.6406 15.75 14.0156 15.8086 13.2051 15.8086C11.2324 15.8086 10.4121 15.0469 10.4219 13.0645V8.19141L10.3145 6.0332L11.3691 7.26367L13.8008 9.71484C14.1328 10.0566 14.5332 10.3008 15.0898 10.3008C16.0371 10.3008 16.7695 9.60742 16.7695 8.54297C16.7695 8.12305 16.5742 7.67383 16.2129 7.3125L9.94336 1.0332C9.63086 0.720703 9.11328 0.515625 8.63477 0.515625C8.15625 0.515625 7.63867 0.720703 7.32617 1.0332L1.04688 7.3125C0.685547 7.67383 0.490234 8.12305 0.490234 8.54297C0.490234 9.60742 1.22266 10.3008 2.16992 10.3008C2.72656 10.3008 3.12695 10.0566 3.45898 9.71484L5.89062 7.26367L6.95508 6.0332L6.84766 8.19141V13.377C6.84766 17.4492 9.14258 19.3828 13.2148 19.3828Z",
  fill: "currentColor"
});

var SvgArrowTop = function SvgArrowTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-top.be5fb30c.svg";
export { ForwardRef as ReactComponent };